import { ValidationProps } from 'ui';
import { Metadata, ScheduleDefinition, ScheduleFailedConstraints } from 'app/area/company-report/types-store';

export const ACTION = {
  REQUEST_SEND_REPORT: 'COMPANY_REPORT:REQUEST_SEND_REPORT',
  RECEIVE_REPORT: 'COMPANY_REPORT:RECEIVE_REPORT',
  FAILED_TO_SEND_REPORT: 'COMPANY_REPORT:FAILED_TO_SEND_REPORT',
  REQUEST_METADATA: 'COMPANY_REPORT:REQUEST_METADATA',
  RECEIVE_METADATA: 'COMPANY_REPORT:RECEIVE_METADATA',
  SET_EMAIL_VALUE: 'COMPANY_REPORT:SET_EMAIL_VALUE',
  CLEAR_FORM: 'COMPANY_REPORT:CLEAR_FORM',
  VALIDATE_REPORT_FILTERS: 'COMPANY_REPORT:VALIDATE_REPORT_FILTERS',
  REQUEST_DELETE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:REQUEST_DELETE_SCHEDULE_DEFINITION',
  RECEIVE_DELETE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:RECEIVE_DELETE_SCHEDULE_DEFINITION',
  FAILED_TO_DELETE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:FAILED_TO_DELETE_SCHEDULE_DEFINITION',
  REQUEST_SCHEDULE_DEFINITION: 'COMPANY_REPORT:REQUEST_SCHEDULE_DEFINITION',
  RECEIVE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:RECEIVE_SCHEDULE_DEFINITION',
  FAILED_TO_RECEIVE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:FAILED_TO_RECEIVE_SCHEDULE_DEFINITION',
  REQUEST_UPDATE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:REQUEST_UPDATE_SCHEDULE_DEFINITION',
  RECEIVE_UPDATE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:RECEIVE_UPDATE_SCHEDULE_DEFINITION',
  FAILED_TO_UPDATE_SCHEDULE_DEFINITION: 'COMPANY_REPORT:FAILED_TO_UPDATE_SCHEDULE_DEFINITION',
  REQUEST_DEFAULT_SCHEDULE_DEFINITION: 'COMPANY_REPORT:REQUEST_DEFAULT_SCHEDULE_DEFINITION',
  RECEIVE_DEFAULT_SCHEDULE_DEFINITION: 'COMPANY_REPORT:RECEIVE_DEFAULT_SCHEDULE_DEFINITION',
  FAILED_TO_RECEIVE_DEFAULT_SCHEDULE_DEFINITION: 'COMPANY_REPORT:FAILED_TO_RECEIVE_DEFAULT_SCHEDULE_DEFINITION',
  REQUEST_CREATE_SPECIAL_REPORT: 'REQUEST_CREATE_SPECIAL_REPORT',
  RECEIVE_CREATE_SPECIAL_REPORT: 'RECEIVE_CREATE_SPECIAL_REPORT'
};

export class RequestSendReport {
  public type: string = ACTION.REQUEST_SEND_REPORT;
}

export class ReceiveReport {
  public type: string = ACTION.RECEIVE_REPORT;
}

export class FailedToSendReport {
  public type: string = ACTION.FAILED_TO_SEND_REPORT;
}

export class RequestMetadata {
  public type: string = ACTION.REQUEST_METADATA;
}

export class ReceiveMetadata {
  public type: string = ACTION.RECEIVE_METADATA;
  public metadata: Metadata;
  public usePredefDate: boolean;
  
  constructor(metadata: Metadata, usePredefDate: boolean) {
    this.metadata = metadata;
    this.usePredefDate = usePredefDate;
  }
}

export class SetEmailValue {
  public type: string = ACTION.SET_EMAIL_VALUE;
  public emails: string;
  public validation: ValidationProps;
  constructor(value: string, validation?: ValidationProps) {
    this.emails = value;
    this.validation = validation;
  }
}

export class ClearForm {
  public type: string = ACTION.CLEAR_FORM;
}

export class ValidateReportFilters {
  public type: string = ACTION.VALIDATE_REPORT_FILTERS;
}
export class RequestDeleteScheduleDefinition {
  public type: string = ACTION.REQUEST_DELETE_SCHEDULE_DEFINITION;
}

export class ReceiveDeleteScheduleDefinition {
  public type: string = ACTION.RECEIVE_DELETE_SCHEDULE_DEFINITION;
}

export class FailedToDeleteScheduleDefinition {
  public type: string = ACTION.FAILED_TO_DELETE_SCHEDULE_DEFINITION;
}

export class RequestScheduleDefinition {
  public type: string = ACTION.REQUEST_SCHEDULE_DEFINITION;
}

export class ReceiveScheduleDefinition {
  public type: string = ACTION.RECEIVE_SCHEDULE_DEFINITION;
  
  constructor(public definition: any) {
    this.definition = definition;
  }
}

export class FailedToReceiveScheduleDefinition {
  public type: string = ACTION.FAILED_TO_RECEIVE_SCHEDULE_DEFINITION;
}

export class RequestUpdateScheduleDefinition {
  public type: string = ACTION.REQUEST_UPDATE_SCHEDULE_DEFINITION;
  constructor(public definition: ScheduleDefinition) {
    this.definition = definition;
  }
}

export class FailedToUpdateScheduleDefinition {
  public type: string = ACTION.FAILED_TO_UPDATE_SCHEDULE_DEFINITION;
}

export class ReceiveUpdateScheduleDefinition {
  public type: string = ACTION.RECEIVE_UPDATE_SCHEDULE_DEFINITION;
  constructor(public scheduleFailedConstraints: ScheduleFailedConstraints) {
    this.scheduleFailedConstraints = scheduleFailedConstraints;
  }
}

export class RequestDefaultScheduleDefinition {
  public type: string = ACTION.REQUEST_DEFAULT_SCHEDULE_DEFINITION;
}
export class ReceiveDefaultScheduleDefinition {
  public type: string = ACTION.RECEIVE_DEFAULT_SCHEDULE_DEFINITION;
  constructor(public definition: ScheduleDefinition) {
    this.definition = definition;
  }
}

export class FailedToReceiveDefaultScheduleDefinition {
  public type: string = ACTION.FAILED_TO_RECEIVE_DEFAULT_SCHEDULE_DEFINITION;
}

export class RequestCreateSpecialReport {
  public type: string = ACTION.REQUEST_CREATE_SPECIAL_REPORT;
}

export class ReceiveCreateSpecialReport {
  public type: string = ACTION.RECEIVE_CREATE_SPECIAL_REPORT;
}
